var _a;
import { createActions } from 'redux-actions';
export var getWaitingTime = (_a = createActions('GET_WAITING_TIME', 'GET_WAITING_TIME_COMPLETE'), _a.getWaitingTime), getWaitingTimeComplete = _a.getWaitingTimeComplete;
